<!-- My Account -->
<div class="myaccount_left--slider myacc-cont">

  <div class="myaccount_left--container">


    <div class="icon-cancel hide-below-992" *ngIf="showAccountCards" (click)="goBack()"></div>

    <div class="myaccount_left--content">
      
      <div class="myaccount_left--content_heading myacc-pages-hdng">
        <h2 class="heading"><p>{{'profileSettingsComp.myAccount' | translate}}</p> <span class="back-icn" (click)="goBack()" *ngIf="showAccountCards"> <small class="show-desk">✕</small><i class="icon icon-arrow-2 show-mobile"></i></span></h2>
      </div>
      <div class="myaccount_inner_wrapper">
        <!--My Account Top Card code-->
        <div class="balance-info">
          <div class="balance-info__card" [ngStyle]="{'background-image': 'url(' + balanceInfoCardBg + ') '}">
            <div class="balance-info__card--top">
              <p class="avail-bal-info">
                <span>{{'profileSettingsComp.availableBalance' | translate}} </span>
                <!-- <span>{{userCurrencySymbol}} {{userTotalBalance | number:'1.2-2'}}</span> -->
              </p>
            </div>
            <div class="balance-info__card--bottom">
              <ul class="list-inline">
                <li class="btm-bal-info cash-bal">
                  {{'headerComp.cashBalance' | translate}} <br> 
                  <span>{{userCashBalance | currencyPipe }}</span>
                </li>
                <li class="btm-bal-info bonus-bal">
                  {{'headerComp.bonusBalance' | translate}} <br> 
                  <span>{{userBonusBalance | currencyPipe }}</span>                 
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Ends -->

        <section class="myaccount_wrap clearfix" *ngIf="showAccountCards">
          <div class="myaccount_card">
            <div class="myaccount_card--body">
              <div class="myaccount_card--body-left">
                <div class="myaccount_card--content">
                  <h4>{{'completeprofileComp.completeprofile3' | translate}}</h4>
                  <p>{{'completeprofileComp.completeprofile4' | translate}}</p>
                </div>
              </div>
              <div class="myaccount_card--body-right">
                <button class="myaccount_card--btn "
                  (click)="navigateToUpdateProfile()">{{'completeprofileComp.completeprofile7' | translate}}</button>
              </div>
            </div>
          </div>
          <div class="myaccount_card">
            <div class="myaccount_card--body">
              <div class="myaccount_card--body-left">
                <div class="myaccount_card--content">
                  <h4>{{'completeprofileComp.completeprofile8' | translate}}</h4>
                  <p>{{'completeprofileComp.completeprofile9' | translate}}</p>
                </div>
              </div>
              <div class="myaccount_card--body-right">
                <button class="myaccount_card--btn"
                  (click)="navigateToPassword()">{{'completeprofileComp.completeprofile10' | translate}}</button>
              </div>
            </div>
          </div>

          <div class="myaccount_card">
            <div class="myaccount_card--body">
              <div class="myaccount_card--body-left">
                <div class="myaccount_card--content">
                  <h4>{{'completeprofileComp.completeprofile16' | translate}}</h4>
                  <p>{{'completeprofileComp.completeprofile17' | translate}}</p>
                </div>
              </div>
              <div class="myaccount_card--body-right">
                <button class="myaccount_card--btn"
                  (click)="navigateToPreference()">{{'completeprofileComp.completeprofile18' | translate}}</button>
              </div>
            </div>
          </div>

          <div class="myaccount_card" *ngIf="isCoolOffAvailable()">
            <div class="myaccount_card--body">
              <div class="myaccount_card--body-left">
                <div class="myaccount_card--content">
                  <h4>{{'completeprofileComp.completeprofile19' | translate}}</h4>
                  <p>{{'completeprofileComp.completeprofile20' | translate}}</p>   
                </div>
              </div>
              <div class="myaccount_card--body-right">
                <button class="myaccount_card--btn" (click)="openCoolOffPopup()" >{{'completeprofileComp.completeprofile21' | translate}}</button>          
              </div>
            </div>
          </div>
        </section>
        <div class="myaccount_logout--btn text-center">
          <h4 class="myaccount_logoutbtn" (click)="doLogout()">
            {{'headerComp.logout' | translate}}</h4>
        </div>
      </div>
    </div>
  </div>
</div>
<modal id="completeProfile" class="modal_smooth_open preferences-modal-popup">
  <div class="no-padding fixed-scroll">
    <div class="site_modal middleAlignBlock preferenceModal" [ngStyle]="{'background-image': 'url(' + siteUrlPath + '/' + mediaPath + '/common/login_bg.png)'}">
      <div class="middleAlign">
        <div class="no-padding site_modal--body site_modal--body-large">
          <div class="hidden-sm hidden-xs icon-cancel-svg" (click)="closeModal('completeProfile')"></div>
          <div class="no-padding">
            <app-preference-center [ngClass]="moduleOpen === 'prepferences' ? 'show' : 'hide'">
            </app-preference-center>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal>
<app-cool-off></app-cool-off>